import { render, staticRenderFns } from "./SetSubAttribute.vue?vue&type=template&id=6787c28e&scoped=true&"
import script from "./SetSubAttribute.vue?vue&type=script&lang=js&"
export * from "./SetSubAttribute.vue?vue&type=script&lang=js&"
import style0 from "./SetSubAttribute.vue?vue&type=style&index=0&id=6787c28e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6787c28e",
  null
  
)

export default component.exports